import {createFileRoute} from '@tanstack/react-router'

import {StockOverviewPage} from '../../../../assets/rental-assets/stock-overview-page'

export const Route = createFileRoute('/_app/rental-assets/stock/$typeId')({
    component: StockOverviewRoute,
})

function StockOverviewRoute() {
    const {typeId} = Route.useParams()

    return <StockOverviewPage typeId={typeId} />
}
